export default __webpack_public_path__ + "static/media/manejo_intoxicacion_co.d1e31f37.pdf";